// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"%234d4c4c\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto', sans-serif;
    min-height: calc(100vh - 100px);
    padding-bottom: 100px;
    text-align: center;
}

.login-form-container {
    width: 100%;
    max-width: 600px;
    padding: 20px;
    margin-top: 30px;
    box-sizing: border-box;
}

.text-center {
    text-align: center;
}

.title-login {
    font-size: 55px;
    color: #047da2;
}

.subtitle-login {
    font-size: 20px;
    margin-bottom: 20px;
}

.message-container {
    display: flex;
    justify-content: center;
    width: 100%;
}

.phone-container {
    display: flex;
    gap: 10px; 
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
    align-items: center;
}

.country-code-wrapper {
    flex-shrink: 0;
    width: auto;
}

.phone-number-input {
    flex-grow: 2;
}

.container-inputs {
    width: 80%;
    margin: 0 auto;
}

.country-code-select-container {
    flex-shrink: 0;
    width: auto;
    margin-bottom: 20px;
}

.country-code-select {
    width: 100%;
    height: 100%;
    background: #CFCCCB;
    border-radius: 15px !important;
    border-color: #CFCCCB !important;
    border: none !important;
    box-sizing: border-box;
    font-size: 0.8rem;
    font-family: 'Roboto', sans-serif;
    color: #4d4c4c !important;
    outline: none;
    appearance: none; 
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: center;
    padding-right: 20px !important; /* Espacio para la flecha del select */
}

.country-code-select option {
    display: flex;
    align-items: center;
    padding: 8px;
}

.country-code-select option svg {
    margin-right: 0.5em;
}


/* Estilos para responsive */
@media (max-width: 768px) {
    .login-page-container {
        flex-direction: column;
    }

    .login-form-container {
        width: 100%;
        max-width: none;
    }

    .login-logo-container{
        margin-top: 50px;
    }

    .title-login{
        font-size: 35px;
    }

    .subtitle-login {
        font-size: 12px;
    }

    .container-inputs {
        width: 100%;
        margin: 0 auto;
    }

    .country-code-wrapper {
        width: 30%;
        flex-grow: 1;
    }

    .phone-number-input {
        flex-grow: 2;
    }

    .country-code-select-container {
        width: 100%;
    }

    .country-code-select-container img {
        width: 1.5em !important;
        margin-right: 0.1em !important;
    }

    .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{
        padding-right: 10px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage/LoginPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,iCAAiC;IACjC,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,yDAA0N;IAC1N,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,8BAA8B,EAAE,sCAAsC;AAC1E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA,4BAA4B;AAC5B;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".login-page-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Roboto', sans-serif;\n    min-height: calc(100vh - 100px);\n    padding-bottom: 100px;\n    text-align: center;\n}\n\n.login-form-container {\n    width: 100%;\n    max-width: 600px;\n    padding: 20px;\n    margin-top: 30px;\n    box-sizing: border-box;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.title-login {\n    font-size: 55px;\n    color: #047da2;\n}\n\n.subtitle-login {\n    font-size: 20px;\n    margin-bottom: 20px;\n}\n\n.message-container {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n}\n\n.phone-container {\n    display: flex;\n    gap: 10px; \n    margin-bottom: 20px;\n    width: 100%;\n    box-sizing: border-box;\n    align-items: center;\n}\n\n.country-code-wrapper {\n    flex-shrink: 0;\n    width: auto;\n}\n\n.phone-number-input {\n    flex-grow: 2;\n}\n\n.container-inputs {\n    width: 80%;\n    margin: 0 auto;\n}\n\n.country-code-select-container {\n    flex-shrink: 0;\n    width: auto;\n    margin-bottom: 20px;\n}\n\n.country-code-select {\n    width: 100%;\n    height: 100%;\n    background: #CFCCCB;\n    border-radius: 15px !important;\n    border-color: #CFCCCB !important;\n    border: none !important;\n    box-sizing: border-box;\n    font-size: 0.8rem;\n    font-family: 'Roboto', sans-serif;\n    color: #4d4c4c !important;\n    outline: none;\n    appearance: none; \n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-image: url('data:image/svg+xml;utf8,<svg fill=\"%234d4c4c\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/><path d=\"M0 0h24v24H0z\" fill=\"none\"/></svg>');\n    background-repeat: no-repeat;\n    background-position-x: 95%;\n    background-position-y: center;\n    padding-right: 20px !important; /* Espacio para la flecha del select */\n}\n\n.country-code-select option {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n}\n\n.country-code-select option svg {\n    margin-right: 0.5em;\n}\n\n\n/* Estilos para responsive */\n@media (max-width: 768px) {\n    .login-page-container {\n        flex-direction: column;\n    }\n\n    .login-form-container {\n        width: 100%;\n        max-width: none;\n    }\n\n    .login-logo-container{\n        margin-top: 50px;\n    }\n\n    .title-login{\n        font-size: 35px;\n    }\n\n    .subtitle-login {\n        font-size: 12px;\n    }\n\n    .container-inputs {\n        width: 100%;\n        margin: 0 auto;\n    }\n\n    .country-code-wrapper {\n        width: 30%;\n        flex-grow: 1;\n    }\n\n    .phone-number-input {\n        flex-grow: 2;\n    }\n\n    .country-code-select-container {\n        width: 100%;\n    }\n\n    .country-code-select-container img {\n        width: 1.5em !important;\n        margin-right: 0.1em !important;\n    }\n\n    .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input{\n        padding-right: 10px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
